const formatHeaderTitle = (headerTitle: string) => {
  return headerTitle.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export { formatHeaderTitle };
